export default "__VITE_ASSET__zdH$Cj2l__"